import React, { useRef, useEffect } from "react";

// Custom cursor: a little gremlin paw.
export const Cursor = () => {
  const paw = useRef(null);

  useEffect(() => {
    const move = (e) => {
      if (paw.current) paw.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    };
    const hoverIn = () => paw.current && paw.current.classList.add("paw-grow");
    const hoverOut = () => paw.current && paw.current.classList.remove("paw-grow");
    window.addEventListener("mousemove", move);
    document.querySelectorAll("a,button").forEach((el) => {
      el.addEventListener("mouseenter", hoverIn);
      el.addEventListener("mouseleave", hoverOut);
    });
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <>
      <style>{`
        @media (pointer: fine) {
          body { cursor: none; }
          a, button { cursor: none; }
        }
        .paw-inner { transition: transform .2s ease; transform: rotate(-14deg); transform-origin: center; }
        .paw-grow .paw-inner { transform: rotate(-14deg) scale(1.35); }
      `}</style>
      <div ref={paw} data-testid="gremlin-paw-cursor" className="hidden md:block fixed top-0 left-0 z-[100] pointer-events-none -ml-[10px] -mt-[8px]">
        <svg className="paw-inner" width="20" height="19" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.3 3.2 L5 5.4 L5.9 3.4 Z" fill="#F6F1E5" />
          <path d="M11.3 1.2 L12 3.4 L12.9 1.4 Z" fill="#F6F1E5" />
          <path d="M18.3 3.2 L19 5.4 L19.9 3.4 Z" fill="#F6F1E5" />
          <ellipse cx="5" cy="7.4" rx="2.5" ry="3.1" fill="#E08C2D" />
          <ellipse cx="12" cy="5.6" rx="2.6" ry="3.2" fill="#E08C2D" />
          <ellipse cx="19" cy="7.4" rx="2.5" ry="3.1" fill="#E08C2D" />
          <path d="M12 10.2c4.6 0 7.7 3 7.7 6.4 0 3.3-2.7 5.6-7.7 5.6s-7.7-2.3-7.7-5.6c0-3.4 3.1-6.4 7.7-6.4z" fill="#E08C2D" />
          <ellipse cx="12" cy="16.4" rx="3" ry="2.2" fill="#0F0F0F" opacity="0.25" />
        </svg>
      </div>
    </>
  );
};
